/*=========================================================================================
  File Name: moduleCategoryActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Api from "@/helpers/api.js";
import {createOptimizationFilter} from "@/store/payloadHelper.js";

export default {
	generateStandardInput({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/standard_input", payload)
				.then((res) => {
					commit("SET_STANDARD_INPUT", res.data);
					resolve(res);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	generateStandardInputFilter({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/standard_input", payload)
				.then((res) => {
					resolve(res);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	optimization({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/optimization", payload)
				.then((res) => {
					resolve(res);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	update({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.put(`/optimization/${payload.id}`, payload.items)
				.then((response) => {
					commit("UPDATE_OPTIMIZATION", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	findById({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/optimization/file", payload)
				.then((res) => {
					resolve(res);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	deleteById({commit}, id) {
		return new Promise((resolve, reject) => {
			Api.delete(`/optimization/${id}`)
				.then((response) => {
					commit("REMOVE_OPTIMIZATION", id);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	optimizationFilter({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = createOptimizationFilter(data);
			Api.post("/optimization/filter", payload)
				.then((res) => {
					commit("SET_OPTIMIZATION", res.data.records);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	getMeshesOpenroutes() {
		return new Promise((resolve, reject) => {
			Api.get("/openroute/mesh")
				.then((res) => {
					resolve(res);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	exportOptimization({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/optimization/export", payload)
				.then((res) => {
					resolve(res);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	generateDownloadOptimization({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/generate_download", payload)
				.then((res) => {
					resolve(res);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	scheduleOptimization({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/optimization/export/datarutas", payload)
				.then((res) => {
					commit("SET_SCHEDULE_DATARUTAS", res.data);
					resolve(res);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	scheduleOptimizationWithWaypoints({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.put("/optimization/export/datarutas", payload)
				.then((res) => {
					commit("SET_SCHEDULE_DATARUTAS_WAYPOINTS", res.data);
					resolve(res);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	UpdateOptimizationFromFile({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/update_input_file", payload)
				.then((res) => {
					resolve(res.data);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	datarutasLogin({commit}) {
		const userInfo = JSON.parse(localStorage.userInfo);
		const data = {
			uid: userInfo.uid,
			email: userInfo.email,
			client_secret: process.env.VUE_APP_CLIENT_SECRET,
		};
		return new Promise((resolve, reject) => {
			fetch(`${process.env.VUE_APP_API_URL_DATARUTAS}/auth/login`, {
				method: "POST",
				body: JSON.stringify(data),
				headers: {
					"Content-Type": "application/json",
				},
			})
				.then((response) => {
					return response.json();
				})
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	repetitionGeneration({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/repeat_generation", payload)
				.then((res) => {
					resolve(res.data);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchEventsWaypointsList({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/datarutas/events/list", payload)
				.then((res) => {
					commit("SET_SCHEDULE_EVENTS_WAYPOINTS", res.data.records);
					resolve(res.data);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};
